import '../Dashboard.css';
import { Form, InputField, TextAreaField } from '@/components/Form';
import { z } from 'zod';
import { useRef, useState } from 'react';
import i18next from 'i18next';
import { Button } from '@/components/Elements';
import { AdminLayout } from '@/components/Layout/AdminLayout';
const schema = z.object({
  title: z.string().min(1, 'Please enter title'),
  description: z.string().min(1, 'Please enter description'),
});

type TicketValues = {
  title: string;
  description: string;
};

const AddTicket = () => {
  const [loading, setLoading] = useState(false);
  const handleSubmit = async (values: TicketValues) => {};
  return (
    <AdminLayout title="">
      <div className="profile-tab">
        <div
          className="profile-container add-ticket border rounded-lg"
          style={{ background: '#FAFAFA' }}
        >
          <h4 className="text-dark f-18 font-semibold border-btm p-3">Add Ticket</h4>
          <div className="profile-content pass-form tikt p-3">
            <Form<TicketValues, typeof schema> onSubmit={handleSubmit} schema={schema} options={{}}>
              {({ register, formState }) => (
                <>
                  <div className="row align-items-center mt-0">
                    <div className="col-12 col-md-9 mb-4">
                      <InputField
                        type="text"
                        placeholder="Enter Title"
                        label={i18next.t('Title')}
                        error={formState.errors['title']}
                        registration={register('title')}
                      />
                    </div>

                    <div className="col-12 col-md-9 mb-4">
                      <TextAreaField
                        rows={5}
                        label="Description"
                        error={formState.errors['description']}
                        registration={register('description')}
                      />
                    </div>
                  </div>
                  <div className="flex justify-start mb-4">
                    <div className="flex gap-2">
                      <Button isLoading={loading} type="submit" className="mt-2">
                        Send
                      </Button>
                    </div>
                  </div>
                </>
              )}
            </Form>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AddTicket;
